import { SolveModeLabel } from 'components/common-form/sidePanel/status/SolveMode';
import { NextErrorsPanel } from 'components/shared/ErrorsPanel/NextErrorsPanel';
import { ErrorSidePanelStatus } from 'components/shared/Price/shared';
import { PriceNext, QuoteStatus } from 'components/shared/PriceNext';

import type { QuoteRejectedOwnProps, QuoteRejectedStateProps } from './QuoteRejected.connect';
import { connectRejected } from './QuoteRejected.connect';

export type RejectedProps = QuoteRejectedOwnProps & QuoteRejectedStateProps;

const emptyArray: readonly [] = [];

export function Component({
  workspaceType,
  productSubtype,
  errors,
  shouldDisplayErrorDetails,
  shouldDisplayStandardErrorMessage = false,
  shouldUseRejectionCode = false,
  solvingMode,
}: RejectedProps) {
  if (workspaceType === 'static' || workspaceType === 'dynamic') {
    return (
      <PriceNext
        className="bg-danger text-danger bg-opacity-10"
        solveMode={
          <SolveModeLabel workspaceType={workspaceType} solvingMode={solvingMode} isMultipleSolvingMode={false} />
        }
        errorPanel={
          <NextErrorsPanel
            className="text-danger"
            layout={shouldDisplayErrorDetails ? 'summaryAndDetails' : 'summaryOnly'}
            standardErrorMessage={shouldDisplayStandardErrorMessage ? 'errorDetails.standardMessage' : undefined}
            productSubtype={productSubtype}
            workflowErrors={errors ?? emptyArray}
            shouldUseRejectionCode={shouldUseRejectionCode}
          />
        }
        quoteStatus={
          <QuoteStatus className="alert alert-danger" icon="block" description="sidePanel.quoteStatus.quoteRejected" />
        }
      />
    );
  }

  return (
    <ErrorSidePanelStatus color="danger">
      <NextErrorsPanel
        layout={shouldDisplayErrorDetails ? 'summaryAndDetails' : 'summaryOnly'}
        standardErrorMessage={shouldDisplayStandardErrorMessage ? 'errorDetails.standardMessage' : undefined}
        productSubtype={productSubtype}
        workflowErrors={errors ?? emptyArray}
        shouldUseRejectionCode={shouldUseRejectionCode}
      />
    </ErrorSidePanelStatus>
  );
}

export const QuoteRejected = connectRejected(Component);
QuoteRejected.displayName = 'QuoteRejected';
